import axios from 'axios'

export default {
  getBanks(){
    return axios.get('/users/banks')
  },

  getUser(params){
    return axios.get(`/users/admin/${params.userId}`)
  },

  updateUser(payload){
    return axios.patch('/users/admin/update', payload)
  },

  deleteUser(payload) {
    return axios.delete('/users/admin', { data: payload })
  },

  searchUser(params){
    console.log('params', params)
    return axios.get(`/users/admin/list${params}`)
  },
  
  getUsers(params){
    const configParams = { ...params }
    const queryString = configParams.query || ''
    delete configParams.query

    return axios.get(`/users/admin/list${queryString}`, { params: configParams })
  }
  

}
